import { createReducer, on } from '@ngrx/store';
import { SafetyAnalyticsActions } from './safety-analytics.actions';
import { SafetyAnalyticsState, initialSafetyAnalyticsState } from './models/safety-analytics-state.models';

export const safetyAnalyticsReducer = createReducer(
  initialSafetyAnalyticsState,

  // Load summary
  on(SafetyAnalyticsActions.loadSummary, (state): SafetyAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SafetyAnalyticsActions.loadSummarySuccess, (state, { summary }): SafetyAnalyticsState => ({
    ...state,
    summary,
    loading: false,
    error: null
  })),
  on(SafetyAnalyticsActions.loadSummaryFailure, (state, { error }): SafetyAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  // Load trend
  on(SafetyAnalyticsActions.loadTrend, (state): SafetyAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SafetyAnalyticsActions.loadTrendSuccess, (state, { trend }): SafetyAnalyticsState => ({
    ...state,
    trend,
    loading: false,
    error: null
  })),
  on(SafetyAnalyticsActions.loadTrendFailure, (state, { error }): SafetyAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  // Load events
  on(SafetyAnalyticsActions.loadEvents, (state): SafetyAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SafetyAnalyticsActions.loadEventsSuccess, (state, { events, totalCount }): SafetyAnalyticsState => ({
    ...state,
    events,
    eventsTotal: totalCount,
    loading: false,
    error: null
  })),
  on(SafetyAnalyticsActions.loadEventsFailure, (state, { error }): SafetyAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  // Clear state
  on(SafetyAnalyticsActions.clearSafetyAnalyticsState, (): SafetyAnalyticsState => ({
    ...initialSafetyAnalyticsState
  })),
);
